<main class="bg-light" style="border-radius:0px;">
  <app-admin-nav ></app-admin-nav>
  <div class="container-fluid py-5 " >
    <div class="row px-4">
      <div class="col-lg-12 py-3" *ngIf="user1!=null">
        <app-linktree-top [username]="user1.userName"></app-linktree-top>
      </div>
    </div>
    <div class="container" *ngIf="user1!=null">
      <div class="row no-gutters">
        <div class="col-lg-12">
         <div class="container" *ngIf="loading">
           <div class="row">
             <div class="col-lg-12">
                  <app-form-spinner></app-form-spinner>
             </div>
           </div>
         </div>
          <div class="card px-4 p-6 mb-5 rounded-4 shadow text-center" *ngIf="user!=null">
             <div class="card-header">
               Download QR Code
             </div>
            <qrcode   class="qrcode"  [qrdata]="username" [width]="250"></qrcode>
            <div class="col-lg-12" *ngIf="!loading">
              <button (click)="GetPkPass(userId)" class="btn btn-primary py-3 rounded-4 mb-2">Download</button>
            </div>
            <div class="col-lg-12" *ngIf="loading">
              <button  class="btn btn-primary py-3 rounded-4 mb-2"><div class="spinner-border text-light" role="status">
                <span class="visually-hidden">Loading...</span>
              </div></button>
            </div>
           <div class="card-footer">
            <a href="{{username}}" target="_blank" class="nav-link text-center ">{{user1.userName}}</a>
           </div>
          </div>
        </div>

       </div>
     </div>
   </div>

</main>




<div class="d-block d-sm-block d-md-block d-lg-none d-xl-none mt-10">
  <app-bottom-nav></app-bottom-nav>
</div>
